import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  DialogActions,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../form/CustomTypography";
import AppButton from "../buttons/AppButton";

interface CustomSuccessPopupProps {
  open: boolean;
  onClose?: () => void;
  icon?: string;
  title: string;
  description: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

const CustomSuccessPopup: React.FC<CustomSuccessPopupProps> = ({
  open,
  onClose,
  icon,
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        textAlign: "center",
      }}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        },
      }}
    >
      <DialogTitle
        sx={{
          pl: 0,
          pr: 0.5,
          pt: 4.5,
          pb: 0,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {/* <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>

      <DialogContent>
        <Box display="flex" justifyContent="center" mb={2}>
          {icon && (
            <img
              src={icon}
              alt="Success Icon"
              width="25%"
              height="auto"
              style={{ marginBottom: 10 }}
            />
          )}
        </Box>

        <CustomTypography variant="heading4" style={{ paddingBottom: 14 }}>
          {title}
        </CustomTypography>

        <CustomTypography variant="body1" style={{ paddingBottom: 14 }}>
          {description}
        </CustomTypography>

        {(primaryButtonText || secondaryButtonText) && (
          <DialogActions
            sx={{
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              mt: 1,
              p: 0,
              mb: 2,
            }}
          >
            {secondaryButtonText && onSecondaryClick && (
              <AppButton
                onClick={onSecondaryClick}
                label={secondaryButtonText}
                customStyles={{
                  minWidth: "10.438rem",
                  border: `1px solid ${theme.palette.customColors.greyTextColor}`,
                  backgroundColor: theme.palette.common.white,
                  color: theme.palette.customColors.blackBorder,
                }}
                variant="grayscale"
              />
            )}

            {primaryButtonText && onPrimaryClick && (
              <AppButton
                label={primaryButtonText}
                onClick={onPrimaryClick}
                customStyles={{
                  minWidth: "10.438rem",
                  backgroundColor: theme.palette.customColors.purple,
                  color: theme.palette.customColors.white,
                }}
                variant="primary"
              />
            )}
          </DialogActions>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CustomSuccessPopup;
